import React from "react";
const IconMadeInDE = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
    <rect
      x="22.1533"
      y="15.1647"
      width="11.6559"
      height="6.86377"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <rect
      x="9.47461"
      y="18.6838"
      width="37.0128"
      height="3.34462"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <rect
      x="8.57373"
      y="22.0284"
      width="38.853"
      height="4.78264"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M6.63086 45.6855H49.3691"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M6.63086 26.8112H49.3691"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M6.63086 22.0284H49.3691"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M8.57373 18.6838H47.4267"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M20.7148 15.1647H35.2847"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M28 15.1647L28 10.3081"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path d="M25.7974 15.0813L24.4011 11.2434" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M22.9102 15.0813L21.8383 12.2072" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M30.2026 14.9978L31.5041 11.2434" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M33.0898 14.9978L34.1883 12.2071" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <rect
      x="8.57275"
      y="26.811"
      width="4.47151"
      height="18.7189"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <rect
      x="16.9297"
      y="26.811"
      width="4.47151"
      height="18.7189"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <rect
      x="34.5977"
      y="26.811"
      width="4.47151"
      height="18.7189"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <rect
      x="42.9541"
      y="26.811"
      width="4.47151"
      height="18.7189"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconMadeInDE;
